import { RSAA } from 'redux-api-middleware';
import * as A from '../actions/emailActions';

export const
getEmailTypes = () => ({ [RSAA]: {
    endpoint: '/email/types',
    method: 'GET',
    types: [
        A.LOAD_MESSAGE_TYPES_REQUEST,
        A.LOAD_MESSAGE_TYPES_SUCCESS,
        A.LOAD_MESSAGE_TYPES_FAILURE
    ]
}}),
getEmailTypesByRole = role => ({ [RSAA]: {
    endpoint: `/email/typesByRole/${role}`,
    method: 'GET',
    types: [
        A.LOAD_MESSAGE_TYPES_REQUEST,
        A.LOAD_MESSAGE_TYPES_SUCCESS,
        A.LOAD_MESSAGE_TYPES_FAILURE
    ]
}}),
getEmailsBySearch = payload => ({ [RSAA]: {
    endpoint: '/email/search',
    body: JSON.stringify(payload),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    types: [
        A.SEARCH_MESSAGES_PENDING,
        {
            type: A.SEARCH_MESSAGE_SUCCESS,
            meta: (action, state, res) => ({ totalCount: parseInt(res.headers.get('emailCount')), paged: parseInt(res.headers.get('paged'))})
        },
        A.SEARCH_MESSAGE_FAILURE
    ]
}}),
getEmail = (id, e) => ({ [RSAA]: {
    endpoint: `/email/${id}`,
    method: 'GET',
    types: [
        { type: A.LOAD_EMAIL_REQUEST, payload: e },
        A.LOAD_EMAIL_SUCCESS,
        A.LOAD_EMAIL_FAILURE
    ]
}}),
getCaseEmail = (guid, e) => ({ [RSAA]: {
    endpoint: `/email/view`,
    method: 'POST',
    body: guid,
    headers: { 'Content-Type': 'application/json' },
    types: [
      A.LOAD_EMAIL_PREVIEW_REQUEST,
      A.LOAD_EMAIL_PREVIEW_SUCCESS,
      A.LOAD_EMAIL_PREVIEW_FAILURE
    ]
}}),
getEmailPreview = emailHash => ({ [RSAA]: {
    endpoint: `/email/preview/`,
    body: JSON.stringify(emailHash),
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    types: [
        A.LOAD_EMAIL_PREVIEW_REQUEST,
        A.LOAD_EMAIL_PREVIEW_SUCCESS,
        A.LOAD_EMAIL_PREVIEW_FAILURE
    ]
}}),
setEmailId = id => ({ type: A.SET_EMAIL_ID, payload: id }),
storeSearchValues = values => ({type: A.STORE_SEARCH_VALUES, payload: values}),
storePagination = (pageNum, pageSize) => ({type: A.STORE_PAGINATION, payload: {pageSize, pageNum}}),
clearEmail = () => ({ type: A.CLEAR_SELECTED_EMAIL }),
resetEmailRequest = () => ({ type: A.RESET_LOAD_EMAIL_REQUEST }),
resetSearchEmails = () => ({ type: A.SEARCH_MESSAGE_RESET });
